// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────────────────
   SIGNIFY SPORTS TOOL 2.0 — DESIGN SYSTEM
   ──────────────────────────────────────────────────────────────────────

   Aligned 2026-05-21 with the OFFICIAL Signify logo SVG, not the
   lightmap-report SPA's CSS. The logo uses a GRADIENT from
   #00e487 (green, offset .5) → #1ecbd0 (teal, offset 1.0). The
   PRIMARY brand color is the green — it dominates the visible logo
   area. The teal at the right edge is a SECONDARY accent.

   First-pass mistake (2026-05-20): I took #1ecbd0 from the report's
   teal-tinted CSS variables and called it "the Signify brand", but
   that was only the gradient end-stop. Fixed by switching primary
   to #00e487 and keeping teal as a secondary token.

   Source of truth for fonts (still): the lightmap-report SPA at
   https://fanta-freak.github.io/lightmap-report/#/report/284
     → "Noto Sans" / "Barlow Condensed" / "JetBrains Mono".

   Legacy variable names (--signify-green*) are KEPT as aliases for
   backward compatibility with inline styles in component files; they
   now resolve to --brand-primary*, which actually IS green.

   ────────────────────────────────────────────────────────────────────── */

:root {
  /* ── Brand colors ─────────────────────────────────────────────────
     Pulled DIRECTLY from the official Signify logo SVG (gradient stops):
        primary green: #00e487 (offset .5, dominates visible logo area)
        secondary teal: #1ecbd0 (offset 1.0, only the right edge of "y")
     Heading ink + status colors match the lightmap-report exactly:
        ink:    #1a1a2e
        pass:   #16a34a   fail: #dc2626   warn: #fbbf24
        muted:  #6b7280
  */
  --brand-primary:       #00e487;   /* primary accent — buttons, bars, badges */
  --brand-primary-deep:  #00b56b;   /* hover/active for primary buttons */
  --brand-primary-soft:  #ccfae9;   /* tints for hover rows, badge bg */
  --brand-primary-faint: #ecfdf6;   /* very soft selection tint */
  --brand-teal:          #1ecbd0;   /* SECONDARY accent (gradient end-stop) */
  --brand-teal-deep:     #15a8ad;
  --brand-ink:           #1a1a2e;   /* heading text */
  --brand-cobalt:        #0096ff;   /* chart series accent, link blue */

  /* ── Semantic status colors (match the report exactly) ──────────── */
  --status-pass:       #16a34a;
  --status-pass-bg:    #dcfce7;
  --status-fail:       #dc2626;
  --status-fail-bg:    #fee2e2;
  --status-warn:       #fbbf24;
  --status-warn-bg:    #fef3c7;
  --status-warn-ink:   #92400e;
  --status-info:       #0096ff;
  --status-info-bg:    #e0f2fe;

  /* ── Text scale (light theme — dark mode out of scope) ─────────── */
  --text-strong:       #1a1a2e;   /* h1-h4 */
  --text-body:         #1f2937;   /* paragraph body */
  --text-muted:        #6b7280;   /* secondary, helper, table headers */
  --text-disabled:     #9ca3af;
  --text-on-brand:     #0a2326;   /* dark text on teal buttons (8.6:1 contrast) */
  --text-on-dark:      #f3f4f6;

  /* ── Surfaces ──────────────────────────────────────────────────
     2026-05-21 round 3: deeper page bg (#dde4ee) so white cards REALLY
     pop. Round 1 used #f4f6fa which Philip called "viel zu weiß". This
     darkens by ~5 luminance steps — still cool blue-tinted, but cards
     now read as floating panels not flat blocks. Card border + shadow
     also bumped to reinforce the elevation. */
  --bg-page:           #dde4ee;   /* tinted canvas under cards */
  --bg-soft:           #eef1f7;   /* table thead, card-header tint */
  --bg-canvas:         #d4dde9;   /* deeper soft for chrome zones */
  --surface-card:      #fff;
  --surface-hover:     #f4f6fa;
  --surface-selected:  var(--brand-primary-faint);

  /* ── Lines ────────────────────────────────────────────────────── */
  --border-default:    #e5e7eb;
  --border-strong:     #d1d5db;
  --border-faint:      #f3f4f6;

  /* ── Shadows (calm, low-elevation; bumped 2026-05-21 round 3) ─── */
  --shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.06);
  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.06), 0 6px 16px rgba(15, 23, 42, 0.08);
  --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.12);
  --shadow-lg: 0 12px 40px rgba(15, 23, 42, 0.20);
  --shadow-focus: 0 0 0 3px rgba(0, 228, 135, 0.28);  /* brand green */

  /* ── Radii (match report) ─────────────────────────────────────── */
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-2xl: 16px;
  --radius-pill: 999px;

  /* ── Spacing rhythm (4-pt base, TIGHTENED 2026-05-21) ────────────
     ui-ux-pro-max skill classified this product as "Data-Dense
     Dashboard" which calls for "minimal padding, space-efficient,
     maximum data visibility". The old scale (8/16/24/32/40) was
     marketing-page generous. Every step shrunk one notch so the
     existing var(--space-N) callsites stay valid but breathe less. */
  --space-1:  4px;
  --space-2:  6px;
  --space-3:  10px;
  --space-4:  12px;
  --space-5:  16px;
  --space-6:  20px;
  --space-8:  24px;
  --space-10: 32px;

  /* ── Typography ──────────────────────────────────────────────────
     The report uses:
       sans  : "Noto Sans"            body, UI, labels
       display: "Barlow Condensed"    h1/h2 hero, KPI numbers
       mono  : "JetBrains Mono"       tabular figures (Em, U, RG, W)
     Fonts are loaded from Google Fonts in public/index.html.
  */
  --font-sans:    "Noto Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  --font-display: "Barlow Condensed", "Barlow", "Noto Sans", system-ui, sans-serif;
  --font-mono:    "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco, monospace;

  /* Type ladder (Tailwind defaults — same ladder the report uses) */
  --type-xs:   12px;
  --type-sm:   14px;
  --type-base: 16px;
  --type-lg:   18px;
  --type-xl:   20px;
  --type-2xl:  24px;
  --type-3xl:  30px;
  --type-4xl:  36px;

  --lh-tight:   1.25;
  --lh-snug:    1.375;
  --lh-normal:  1.5;
  --lh-relaxed: 1.625;

  --tracking-tight:   -0.01em;
  --tracking-normal:  0;
  --tracking-wide:    0.025em;
  --tracking-wider:   0.05em;     /* table headers, eyebrow labels */
  --tracking-widest:  0.1em;

  /* ── Motion (kept short per UI-Pro-Max guidance: 150-300ms) ─── */
  --motion-fast:   120ms;
  --motion-base:   180ms;
  --motion-slow:   240ms;
  --ease-out:      cubic-bezier(0.16, 1, 0.3, 1);
  --ease-in-out:   cubic-bezier(0.4, 0, 0.2, 1);

  /* ── Legacy aliases (kept so existing inline styles keep working) */
  --signify-green:       var(--brand-primary);
  --signify-green-deep:  var(--brand-primary-deep);
  --signify-green-soft:  var(--brand-primary-soft);
  --signify-ink:         var(--brand-ink);
  --signify-text:        var(--text-body);
  --signify-muted:       var(--text-muted);
  --signify-border:      var(--border-default);
  --signify-bg-soft:     var(--bg-soft);
  --signify-card:        var(--surface-card);
  --signify-shadow:      var(--shadow-sm);
}

/* ──────────────────────────────────────────────────────────────────────
   Base reset + body font
   ────────────────────────────────────────────────────────────────────── */

* { margin: 0; padding: 0; box-sizing: border-box; }

html, body, #root { height: 100%; }

body {
  font-family: var(--font-sans);
  font-size: var(--type-base);
  line-height: var(--lh-normal);
  color: var(--text-body);
  background: var(--bg-page);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Improves readability of body text and tabular numerals */
  font-feature-settings: "kern", "liga", "calt";
  font-variant-numeric: lining-nums proportional-nums;
}

/* Headings inherit Noto Sans by default; pages can opt in to the
   Barlow Condensed display face by adding class .display. */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-sans);
  color: var(--text-strong);
  line-height: var(--lh-tight);
  letter-spacing: var(--tracking-tight);
  font-weight: 700;
}
.display, .display h1, .display h2 {
  font-family: var(--font-display);
  font-weight: 600;
  letter-spacing: var(--tracking-normal);
  text-transform: none;
}

/* Use mono for any number that would jitter when values change
   (Fitness, Em, U, RG, Wattage columns). Apply via class .num. */
.num, .tabular {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums lining-nums;
  font-feature-settings: "tnum";
}

/* Focus ring matches the report's teal accent. Applied to all
   interactive elements via :focus-visible so mouse users still
   get a clean look. */
:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
  border-radius: var(--radius-sm);
}

/* ──────────────────────────────────────────────────────────────────────
   App layout (legacy class names kept — used by Sidebar / MapView)
   ────────────────────────────────────────────────────────────────────── */

.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: var(--bg-page);
}

.top-bar {
  height: 60px;
  background-color: var(--surface-card);
  display: flex;
  align-items: center;
  padding: 0 var(--space-4);
  gap: var(--space-4);
  flex-shrink: 0;
  border-bottom: 1px solid var(--border-default);
}

.main-content {
  display: flex;
  flex: 1 1;
  min-height: 0;
}

.sidebar {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--surface-card);
  border-right: 1px solid var(--border-default);
}

.sidebar-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  background-color: inherit;
}

.map-wrapper {
  flex: 1 1;
  min-height: 0;
  display: flex;
}

.map {
  width: 100%;
  flex: 1 1;
}

/* ──────────────────────────────────────────────────────────────────────
   Section heading with green-bar (kept from 2026-05-20 brand pass)
   Used by ProjectsListPage / CreateProjectPage / ProjectDetailPage.
   ────────────────────────────────────────────────────────────────────── */

.section-title {
  position: relative;
  padding-left: 12px;             /* tightened */
  margin-bottom: 14px;            /* tightened */
}
.section-title::before {
  content: "";
  position: absolute;
  left: 0; top: 4px; bottom: 4px;
  width: 3px;                     /* thinner accent bar */
  border-radius: 2px;
  background: var(--brand-primary);
}
.section-title h2 {
  font-size: var(--type-xl);      /* 20px — was 24px, less hero-y */
  font-weight: 700;
  color: var(--text-strong);
  margin: 0;
  letter-spacing: var(--tracking-tight);
  line-height: 1.2;
}
.section-title .subtitle {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

/* ──────────────────────────────────────────────────────────────────────
   Report-style card (kept) + new variations
   ────────────────────────────────────────────────────────────────────── */

.report-card {
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);     /* was xl (12px); 8px feels less marketing */
  box-shadow: var(--shadow-sm);
  /* No \`overflow: hidden\` here — that would clip the horizontal
     scrollbar that .report-card-body.flush creates when the table
     overflows. Border-radius still clips visual corners visually. */
  margin-bottom: 12px;                 /* was --space-5 (16) */
}
.report-card-header {
  padding: 10px 14px;                  /* tightened */
  background: var(--bg-soft);
  border-bottom: 1px solid var(--border-default);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  /* Clip the header's own bg to the card's rounded top corners. */
  border-top-left-radius: var(--radius-lg);
  border-top-right-radius: var(--radius-lg);
}
.report-card-header h3 {
  font-size: 14px;                     /* was --type-lg (18) — more "tab header" */
  font-weight: 700;
  color: var(--text-strong);
  margin: 0;
  letter-spacing: 0;
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
}
.report-card-header .subtitle {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 2px;
}
.report-card-body {
  padding: 12px 14px;                  /* was --space-4 (16) --space-5 (20) */
}

/* ──────────────────────────────────────────────────────────────────────
   Buttons — primary / secondary / ghost / icon
   Sizes: md (default), sm, lg
   ────────────────────────────────────────────────────────────────────── */

.btn {
  /* Reset */
  appearance: none;
  -webkit-appearance: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: var(--radius-md);   /* 6px — tighter, less "marketing pill" */
  padding: 7px 14px;                 /* was 10/16 */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  text-decoration: none;
  transition:
    background-color var(--motion-base) var(--ease-out),
    border-color     var(--motion-base) var(--ease-out),
    color            var(--motion-base) var(--ease-out),
    box-shadow       var(--motion-base) var(--ease-out),
    transform        var(--motion-fast) var(--ease-out);
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}
.btn:active:not(:disabled) {
  transform: translateY(1px);
}
.btn:disabled,
.btn[aria-disabled="true"] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

/* Primary — teal fill, dark ink text (8.6:1 contrast = AAA) */
.btn-primary {
  background: var(--brand-primary);
  color: var(--text-on-brand);
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-xs);
}
.btn-primary:hover:not(:disabled) {
  background: var(--brand-primary-deep);
  border-color: var(--brand-primary-deep);
  box-shadow: var(--shadow-sm);
}

/* Secondary — white surface, teal border + ink text */
.btn-secondary {
  background: var(--surface-card);
  color: var(--text-strong);
  border-color: var(--border-strong);
}
.btn-secondary:hover:not(:disabled) {
  background: var(--bg-soft);
  border-color: var(--brand-primary);
  color: var(--brand-primary-deep);
}

/* Ghost — text-only, hover reveals soft surface */
.btn-ghost {
  background: transparent;
  color: var(--text-muted);
  border-color: transparent;
}
.btn-ghost:hover:not(:disabled) {
  background: var(--bg-soft);
  color: var(--text-strong);
}

/* Danger — used for destructive actions in the LDT modal */
.btn-danger {
  background: var(--surface-card);
  color: var(--status-fail);
  border-color: var(--status-fail);
}
.btn-danger:hover:not(:disabled) {
  background: var(--status-fail-bg);
}

/* Sizes — tightened 2026-05-21 */
.btn-sm { padding: 4px 10px; font-size: 12px; border-radius: var(--radius-sm); }
.btn-lg { padding: 9px 18px; font-size: var(--type-sm); }

/* Icon-only button (✎ ✕ archive). Square hit area 30px — still meets
   the 24px minimum touch target for desktop tools; 44px is mobile-only
   guidance and would dwarf the row. */
.btn-icon {
  padding: 0;
  width: 30px; height: 30px;
  border-radius: var(--radius-sm);
  background: var(--surface-card);
  color: var(--text-muted);
  border-color: var(--border-default);
  font-size: 13px;
}
.btn-icon:hover:not(:disabled) {
  background: var(--bg-soft);
  color: var(--text-strong);
  border-color: var(--border-strong);
}

/* Backward-compat: legacy .app-button used by the wizard top bar */
.app-button {
  padding: 8px 14px;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-strong);
  background-color: var(--bg-soft);
  color: var(--text-strong);
  text-align: left;
  font-size: var(--type-sm);
  font-weight: 500;
  font-family: inherit;
  transition: all var(--motion-base) var(--ease-out);
  margin-right: var(--space-2);
  cursor: pointer;
}
.app-button:hover:not(:disabled) {
  background-color: #fff;
  border-color: var(--brand-primary);
  color: var(--brand-primary-deep);
}
.app-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.app-dropdown {
  height: 36px;
  padding: 0 12px;
  font-size: var(--type-sm);
  font-family: inherit;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-strong);
  background-color: var(--surface-card);
  color: var(--text-strong);
  cursor: pointer;
  max-width: 280px;
  text-overflow: ellipsis;
}
.app-dropdown:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-focus);
}

/* ──────────────────────────────────────────────────────────────────────
   Form fields — label, input, select, textarea
   ────────────────────────────────────────────────────────────────────── */

.field {
  display: block;
  margin-top: 10px;          /* tightened from --space-4 */
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-strong);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
  margin-bottom: 4px;
}
.field-input,
.field-select,
.field-textarea {
  width: 100%;
  padding: 7px 10px;         /* tightened from 10/12 */
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  background: var(--surface-card);
  color: var(--text-strong);
  font-size: var(--type-sm);
  font-family: inherit;
  line-height: 1.4;
  box-sizing: border-box;
  transition: border-color var(--motion-base) var(--ease-out),
              box-shadow   var(--motion-base) var(--ease-out);
}
.field-input::placeholder,
.field-textarea::placeholder { color: var(--text-disabled); }

.field-input:focus,
.field-select:focus,
.field-textarea:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: var(--shadow-focus);
}

.field-input[readonly] {
  background: var(--bg-soft);
  color: var(--text-muted);
}

.field-help {
  font-size: var(--type-xs);
  color: var(--text-muted);
  margin-top: 6px;
}

.field-error {
  font-size: var(--type-xs);
  color: var(--status-fail);
  margin-top: 6px;
  font-weight: 500;
}

/* ──────────────────────────────────────────────────────────────────────
   Data table — used by ProjectsListPage, ProjectDetailPage, LDT modal
   Goal: dense, scannable, with a soft hover lane and a clear-but-quiet
   header row matching the report's table styling.
   ────────────────────────────────────────────────────────────────────── */

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;          /* one notch under sm — engineering-table density */
  color: var(--text-body);
  /* 2026-05-21 round 4: explicit fixed layout. Combined with
     <colgroup>-defined percentage widths (set per-table by the
     consuming component), this GUARANTEES all columns fit in the
     viewport — auto-layout was overflowing because content varied
     too much. "Fixed" here means "browser respects the col widths",
     NOT "pixel-hardcoded". Long cell content is clipped with
     text-overflow on data cells. */
  table-layout: fixed;
}
.data-table td {
  overflow: hidden;
  text-overflow: ellipsis;
}
.data-table thead th {
  text-align: left;
  padding: 7px 10px;        /* tightened more 2026-05-21 round 2 */
  background: var(--bg-soft);
  border-bottom: 1px solid var(--border-default);
  font-size: 11px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
  /* Headers can wrap onto a second line — without this, long German
     labels ("LETZTE BERECHNUNG") force the whole column wider than
     the viewport. Wrapping costs vertical space (one extra row), saves
     horizontal space (column fits in the viewport without scroll). */
  white-space: normal;
  line-height: 1.2;
}
.data-table thead th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color var(--motion-base) var(--ease-out);
}
.data-table thead th.sortable:hover {
  color: var(--brand-primary-deep);
}
.data-table tbody td {
  padding: 8px 12px;        /* tightened 2026-05-21: was 14/16 */
  border-bottom: 1px solid var(--border-faint);
  font-size: 13px;
  vertical-align: middle;
}
.data-table tbody tr {
  transition: background-color var(--motion-fast) var(--ease-out);
}
.data-table tbody tr:hover {
  background: var(--bg-soft);
}
.data-table tbody tr:last-child td {
  border-bottom: none;
}
/* Numeric / monospaced data cells (Fitness, Em, U, RG, W) */
.data-table td.num,
.data-table th.num {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  text-align: right;
}
/* Right-aligned action cells */
.data-table .actions {
  text-align: right;
  white-space: nowrap;
}
.data-table .actions .btn {
  margin-left: 4px;
}
/* "Highlighted" row variant — used for the recommended Calculation */
.data-table tr.is-recommended {
  background: var(--brand-primary-faint);
}
.data-table tr.is-recommended:hover {
  background: var(--brand-primary-soft);
}
.data-table tr.is-recommended td:first-child {
  /* Inner left-accent stripe to make the row pop without changing layout */
  box-shadow: inset 3px 0 0 var(--brand-primary);
}

/* When a table lives inside a .report-card-body the body shouldn't pad
   it — apply via .report-card-body.flush. Also allow horizontal scroll
   inside the card so a wide table doesn't clip at narrow viewports
   (the page chrome / KPI strip / header buttons stay put either way). */
.report-card-body.flush {
  padding: 0;
  overflow-x: auto;
}

/* ──────────────────────────────────────────────────────────────────────
   Status pills / badges — soft tinted backgrounds, color-coded
   ────────────────────────────────────────────────────────────────────── */

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: var(--radius-pill);
  font-size: var(--type-xs);
  font-weight: 600;
  letter-spacing: var(--tracking-wide);
  line-height: 1.4;
  white-space: nowrap;
}
.pill-neutral  { background: var(--bg-soft);            color: var(--text-muted); }
.pill-brand    { background: var(--brand-primary-soft);    color: var(--brand-primary-deep); }
.pill-pass     { background: var(--status-pass-bg);     color: var(--status-pass); }
.pill-fail     { background: var(--status-fail-bg);     color: var(--status-fail); }
.pill-warn     { background: var(--status-warn-bg);     color: var(--status-warn-ink); }
.pill-info     { background: var(--status-info-bg);     color: var(--status-info); }
.pill-archived { background: var(--bg-soft);            color: var(--text-disabled); }

/* Solid recommendation badge (★ Empfehlung) — the "winner" marker */
.badge-recommend {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: var(--radius-pill);
  background: var(--brand-primary);
  color: var(--text-on-brand);
  font-size: var(--type-xs);
  font-weight: 700;
  letter-spacing: var(--tracking-wide);
  white-space: nowrap;
}

/* ──────────────────────────────────────────────────────────────────────
   KPI card — compact card showing a single metric. Used by the
   ProjectDetailPage "Karten" view to render each Calculation variant.
   ────────────────────────────────────────────────────────────────────── */

.kpi-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4);
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xs);
  transition: box-shadow var(--motion-base) var(--ease-out),
              border-color var(--motion-base) var(--ease-out),
              transform var(--motion-fast) var(--ease-out);
}
.kpi-card:hover {
  box-shadow: var(--shadow-sm);
  border-color: var(--border-strong);
  transform: translateY(-1px);
}
.kpi-card.is-recommended {
  border-color: var(--brand-primary);
  background:
    linear-gradient(180deg, var(--brand-primary-faint) 0%, var(--surface-card) 50%);
  box-shadow: var(--shadow-sm);
}
.kpi-card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-2);
}
.kpi-card-title {
  font-size: var(--type-sm);
  font-weight: 700;
  color: var(--text-strong);
}
.kpi-card-meta {
  font-size: var(--type-xs);
  color: var(--text-muted);
}
.kpi-row {
  display: flex;
  justify-content: space-between;
  font-size: var(--type-sm);
  color: var(--text-body);
}
.kpi-row .label { color: var(--text-muted); }
.kpi-row .value {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: var(--text-strong);
}
.kpi-card-actions {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-2);
}

/* ──────────────────────────────────────────────────────────────────────
   KPI strip — horizontal row of compact metric tiles, sits at the top
   of dashboard-like list views (skill recommendation: data-dense
   dashboards put key metrics near the top so the user gets the state
   of the world in one glance before scrolling).
   ────────────────────────────────────────────────────────────────────── */

.kpi-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}
.kpi-tile {
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
  overflow: hidden;
}
.kpi-tile::before {
  /* Thin accent stripe on the left, matches the section-title bar
     language without taking space. Per-variant color below. */
  content: "";
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  background: var(--brand-primary);
}
.kpi-tile.is-pass::before { background: var(--status-pass); }
.kpi-tile.is-warn::before { background: var(--status-warn); }
.kpi-tile.is-fail::before { background: var(--status-fail); }
.kpi-tile.is-mute::before { background: var(--text-disabled); }

.kpi-tile-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: var(--tracking-wider);
}
.kpi-tile-value {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-strong);
  line-height: 1.1;
}
.kpi-tile-sub {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 2px;
}

/* ──────────────────────────────────────────────────────────────────────
   Modal — used by LDTManagerModal (backdrop + centered card + sticky head)
   ────────────────────────────────────────────────────────────────────── */

.modal-backdrop {
  position: fixed; inset: 0;
  background-color: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(2px);
  display: flex; align-items: center; justify-content: center;
  z-index: 9000;
  animation: modalFade var(--motion-base) var(--ease-out);
}
.modal-card {
  position: relative;
  background-color: var(--surface-card);
  width: 92%;
  max-width: 1000px;
  max-height: 88vh;
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-lg);
  display: flex; flex-direction: column;
  overflow: hidden;
  animation: modalSlide var(--motion-slow) var(--ease-out);
}
.modal-header {
  padding: var(--space-5) var(--space-6);
  border-bottom: 1px solid var(--border-default);
  display: flex; align-items: center; justify-content: space-between;
  flex-shrink: 0;
}
.modal-header h2 {
  font-size: var(--type-xl);
  font-weight: 700;
  color: var(--text-strong);
  margin: 0;
  letter-spacing: var(--tracking-tight);
}
.modal-header .modal-meta {
  font-size: var(--type-xs);
  color: var(--text-muted);
  margin-left: var(--space-3);
  font-weight: 500;
}
.modal-close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: var(--text-muted);
  cursor: pointer;
  padding: 6px 10px;
  border-radius: var(--radius-md);
  transition: background-color var(--motion-fast) var(--ease-out),
              color var(--motion-fast) var(--ease-out);
}
.modal-close:hover {
  background: var(--bg-soft);
  color: var(--text-strong);
}
.modal-body {
  padding: var(--space-5) var(--space-6);
  overflow-y: auto;
  flex-grow: 1;
}

@keyframes modalFade {
  from { opacity: 0; }
  to   { opacity: 1; }
}
@keyframes modalSlide {
  from { opacity: 0; transform: translateY(8px) scale(0.99); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* ──────────────────────────────────────────────────────────────────────
   Inline banner — alerts inside a card or modal
   ────────────────────────────────────────────────────────────────────── */

.banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  font-size: var(--type-sm);
  border: 1px solid transparent;
  line-height: var(--lh-snug);
}
.banner-warn {
  background: var(--status-warn-bg);
  border-color: var(--status-warn);
  color: var(--status-warn-ink);
}
.banner-fail {
  background: var(--status-fail-bg);
  border-color: var(--status-fail);
  color: var(--status-fail);
}
.banner-info {
  background: var(--status-info-bg);
  border-color: var(--brand-cobalt);
  color: var(--brand-cobalt);
}

/* ──────────────────────────────────────────────────────────────────────
   Toast — bottom-center floating message
   ────────────────────────────────────────────────────────────────────── */

.toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--text-strong);
  color: #fff;
  padding: 12px 20px;
  border-radius: var(--radius-lg);
  font-size: var(--type-sm);
  font-weight: 500;
  box-shadow: var(--shadow-lg);
  z-index: 9999;
  pointer-events: none;
  animation: toastIn var(--motion-base) var(--ease-out);
  max-width: 90vw;
  text-align: center;
}
@keyframes toastIn {
  from { opacity: 0; transform: translate(-50%, 8px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
}

/* ──────────────────────────────────────────────────────────────────────
   AppHeader chrome (used by the new restructure's top nav)
   ────────────────────────────────────────────────────────────────────── */

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px;             /* was 12/32 — leaner top bar */
  background: var(--surface-card);
  border-bottom: 1px solid var(--border-default);
  flex-shrink: 0;
  gap: var(--space-6);
}
.app-header-left {
  display: flex; align-items: center; gap: var(--space-6);
}
.app-header-brand {
  display: flex; align-items: center; gap: var(--space-3);
  text-decoration: none;
}
.app-header-brand img {
  height: 26px;                  /* tightened with the header */
  width: auto;
  display: block;
}
.app-header-divider {
  width: 1px;
  height: 22px;
  background: var(--border-default);
}
.app-header-subtitle {
  font-size: var(--type-xs);
  font-weight: 600;
  color: var(--text-strong);
  letter-spacing: var(--tracking-wider);
  text-transform: uppercase;
}
.app-header-nav {
  display: flex;
  align-items: center;
  gap: var(--space-1);
}
.app-header-nav-link,
.app-header-nav-btn {
  display: inline-flex;
  align-items: center;
  padding: 8px 14px;
  font-family: inherit;
  font-size: var(--type-sm);
  font-weight: 500;
  color: var(--text-body);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  text-decoration: none;
  cursor: pointer;
  transition:
    color var(--motion-base) var(--ease-out),
    border-color var(--motion-base) var(--ease-out);
}
.app-header-nav-link:hover,
.app-header-nav-btn:hover {
  color: var(--brand-primary-deep);
}
.app-header-nav-link.is-active {
  color: var(--text-strong);
  font-weight: 700;
  border-bottom-color: var(--brand-primary);
}

/* ──────────────────────────────────────────────────────────────────────
   Misc — view-toggle pills, empty state, address suggestion dropdown
   ────────────────────────────────────────────────────────────────────── */

.view-toggle {
  display: inline-flex;
  padding: 4px;
  background: var(--bg-soft);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  gap: 2px;
}
.view-toggle button {
  appearance: none;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: var(--type-xs);
  font-weight: 600;
  color: var(--text-muted);
  padding: 6px 14px;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: background-color var(--motion-fast) var(--ease-out),
              color var(--motion-fast) var(--ease-out);
}
.view-toggle button:hover {
  color: var(--text-strong);
}
.view-toggle button.is-active {
  background: var(--surface-card);
  color: var(--brand-primary-deep);
  box-shadow: var(--shadow-xs);
}

.empty-state {
  padding: var(--space-8) var(--space-6);
  text-align: center;
  color: var(--text-muted);
  font-size: var(--type-sm);
  background: var(--bg-soft);
  border: 1px dashed var(--border-default);
  border-radius: var(--radius-xl);
}

/* Nominatim suggestion dropdown */
.suggest-menu {
  position: absolute;
  top: 100%; left: 0; right: 0;
  z-index: 50;
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  max-height: 240px;
  overflow-y: auto;
  margin-top: 4px;
  padding: 4px;
}
.suggest-item {
  padding: 8px 12px;
  font-size: var(--type-sm);
  cursor: pointer;
  border-radius: var(--radius-md);
  color: var(--text-body);
  transition: background-color var(--motion-fast) var(--ease-out);
}
.suggest-item:hover {
  background: var(--brand-primary-faint);
  color: var(--brand-primary-deep);
}

/* ──────────────────────────────────────────────────────────────────────
   Tape measure popup (kept from the wizard map)
   ────────────────────────────────────────────────────────────────────── */
.tape-measure-popup .maplibregl-popup-content {
  background: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  border: none !important;
}
.tape-measure-popup .maplibregl-popup-tip { display: none !important; }

/* ──────────────────────────────────────────────────────────────────────
   Accessibility helpers (per UI-Pro-Max §1)
   ────────────────────────────────────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  *, *::before, *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;2EAuB2E;;AAE3E;EACE;;;;;;;;GAQC;EACD,8BAA8B,IAAI,2CAA2C;EAC7E,8BAA8B,IAAI,qCAAqC;EACvE,8BAA8B,IAAI,mCAAmC;EACrE,8BAA8B,IAAI,6BAA6B;EAC/D,8BAA8B,IAAI,yCAAyC;EAC3E,8BAA8B;EAC9B,8BAA8B,IAAI,iBAAiB;EACnD,8BAA8B,IAAI,mCAAmC;;EAErE,sEAAsE;EACtE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,qEAAqE;EACrE,4BAA4B,IAAI,UAAU;EAC1C,4BAA4B,IAAI,mBAAmB;EACnD,4BAA4B,IAAI,qCAAqC;EACrE,4BAA4B;EAC5B,4BAA4B,IAAI,+CAA+C;EAC/E,4BAA4B;;EAE5B;;;;;8CAK4C;EAC5C,4BAA4B,IAAI,8BAA8B;EAC9D,4BAA4B,IAAI,kCAAkC;EAClE,4BAA4B,IAAI,iCAAiC;EACjE,yBAAyB;EACzB,4BAA4B;EAC5B,+CAA+C;;EAE/C,oEAAoE;EACpE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,oEAAoE;EACpE,6CAA6C;EAC7C,gFAAgF;EAChF,8CAA8C;EAC9C,+CAA+C;EAC/C,iDAAiD,GAAG,gBAAgB;;EAEpE,oEAAoE;EACpE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;;EAEpB;;;;;qEAKmE;EACnE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB;;;;;;GAMC;EACD,qFAAqF;EACrF,gFAAgF;EAChF,wFAAwF;;EAExF,kEAAkE;EAClE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;;EAEnB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B,MAAM,kCAAkC;EAClE,yBAAyB;;EAEzB,kEAAkE;EAClE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8CAA8C;EAC9C,6CAA6C;;EAE7C,oEAAoE;EACpE,2CAA2C;EAC3C,gDAAgD;EAChD,gDAAgD;EAChD,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,4CAA4C;EAC5C,qCAAqC;EACrC,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;;2EAE2E;;AAE3E,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD,oBAAoB,YAAY,EAAE;;AAElC;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,2DAA2D;EAC3D,6CAA6C;EAC7C,mDAAmD;AACrD;;AAEA;4DAC4D;AAC5D;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;iEACiE;AACjE;EACE,6BAA6B;EAC7B,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;;sBAEsB;AACtB;EACE,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;;2EAE2E;;AAE3E;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAO;AACT;;AAEA;;;2EAG2E;;AAE3E;EACE,kBAAkB;EAClB,kBAAkB,cAAc,cAAc;EAC9C,mBAAmB,aAAa,cAAc;AAChD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC9B,UAAU,sBAAsB,uBAAuB;EACvD,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,yBAAyB,OAAO,iCAAiC;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;2EAE2E;;AAE3E;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B,MAAM,4CAA4C;EACjF,4BAA4B;EAC5B;;oEAEkE;EAClE,mBAAmB,kBAAkB,uBAAuB;AAC9D;AACA;EACE,kBAAkB,mBAAmB,cAAc;EACnD,0BAA0B;EAC1B,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gEAAgE;EAChE,wCAAwC;EACxC,yCAAyC;AAC3C;AACA;EACE,eAAe,sBAAsB,2CAA2C;EAChF,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,kBAAkB,mBAAmB,sCAAsC;AAC7E;;AAEA;;;2EAG2E;;AAE3E;EACE,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,+BAA+B,IAAI,yCAAyC;EAC5E,iBAAiB,kBAAkB,cAAc;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB;;;;;uDAKqD;EACrD,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA,sDAAsD;AACtD;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD;EACE,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;;AAEA,iCAAiC;AACjC,UAAU,iBAAiB,EAAE,eAAe,EAAE,+BAA+B,EAAE;AAC/E,UAAU,iBAAiB,EAAE,yBAAyB,EAAE;;AAExD;;sCAEsC;AACtC;EACE,UAAU;EACV,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,sCAAsC;EACtC,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,kDAAkD;EAClD,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;EAC/B,sCAAsC;EACtC,qCAAqC;EACrC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;;2EAE2E;;AAE3E;EACE,cAAc;EACd,gBAAgB,WAAW,6BAA6B;AAC1D;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,iBAAiB,UAAU,yBAAyB;EACpD,sCAAsC;EACtC,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB;6DAC2D;AAC7D;AACA;+BAC+B,2BAA2B,EAAE;;AAE5D;;;EAGE,aAAa;EACb,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;2EAI2E;;AAE3E;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe,WAAW,mDAAmD;EAC7E,uBAAuB;EACvB;;;;;;mCAMiC;EACjC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB,SAAS,sCAAsC;EAChE,0BAA0B;EAC1B,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qCAAqC;EACrC;;;qEAGmE;EACnE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oDAAoD;AACtD;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB,SAAS,oCAAoC;EAC9D,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,+DAA+D;AACjE;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA,4DAA4D;AAC5D;;EAEE,6BAA6B;EAC7B,kCAAkC;EAClC,iBAAiB;AACnB;AACA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA,qEAAqE;AACrE;EACE,sCAAsC;AACxC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yEAAyE;EACzE,8CAA8C;AAChD;;AAEA;;;wEAGwE;AACxE;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;2EAE2E;;AAE3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;AACA,iBAAiB,0BAA0B,aAAa,wBAAwB,EAAE;AAClF,iBAAiB,qCAAqC,KAAK,gCAAgC,EAAE;AAC7F,iBAAiB,iCAAiC,MAAM,yBAAyB,EAAE;AACnF,iBAAiB,iCAAiC,MAAM,yBAAyB,EAAE;AACnF,iBAAiB,iCAAiC,MAAM,6BAA6B,EAAE;AACvF,iBAAiB,iCAAiC,MAAM,yBAAyB,EAAE;AACnF,iBAAiB,0BAA0B,aAAa,2BAA2B,EAAE;;AAErF,oEAAoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;2EAG2E;;AAE3E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B;;0DAEwD;AAC1D;AACA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC;mFACiF;EACjF,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;AACzB;AACA,kBAAkB,wBAAwB,EAAE;AAC5C;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;;2EAK2E;;AAE3E;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;8DAC4D;EAC5D,WAAW;EACX,kBAAkB;EAClB,OAAO,EAAE,MAAM,EAAE,SAAS;EAC1B,UAAU;EACV,gCAAgC;AAClC;AACA,4BAA4B,8BAA8B,EAAE;AAC5D,4BAA4B,8BAA8B,EAAE;AAC5D,4BAA4B,8BAA8B,EAAE;AAC5D,4BAA4B,gCAAgC,EAAE;;AAE9D;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;2EAE2E;;AAE3E;EACE,eAAe,EAAE,QAAQ;EACzB,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,aAAa;EACb,uDAAuD;AACzD;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa,EAAE,sBAAsB;EACrC,gBAAgB;EAChB,wDAAwD;AAC1D;AACA;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;EACT,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B;sDACoD;AACtD;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,oCAAoC,EAAE;AAC3D;;AAEA;;2EAE2E;;AAE3E;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;2EAE2E;;AAE3E;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;EACpB,qDAAqD;EACrD,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,OAAO,UAAU,EAAE,+BAA+B,EAAE;EACpD,OAAO,UAAU,EAAE,6BAA6B,EAAE;AACpD;;AAEA;;2EAE2E;;AAE3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB,cAAc,+BAA+B;EAC9D,+BAA+B;EAC/B,8CAA8C;EAC9C,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;AACzD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB;EACvD,qBAAqB;AACvB;AACA;EACE,YAAY,mBAAmB,8BAA8B;EAC7D,WAAW;EACX,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf;;mDAEiD;AACnD;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;2EAE2E;;AAE3E;EACE,oBAAoB;EACpB,YAAY;EACZ,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf;sDACoD;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,WAAW;EACX,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,+BAA+B;EAC/B,uBAAuB;EACvB,+DAA+D;AACjE;AACA;EACE,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;;2EAE2E;AAC3E;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;AACA,4CAA4C,wBAAwB,EAAE;;AAEtE;;2EAE2E;AAC3E;EACE;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;EACzC;AACF","sourcesContent":["/* ──────────────────────────────────────────────────────────────────────\n   SIGNIFY SPORTS TOOL 2.0 — DESIGN SYSTEM\n   ──────────────────────────────────────────────────────────────────────\n\n   Aligned 2026-05-21 with the OFFICIAL Signify logo SVG, not the\n   lightmap-report SPA's CSS. The logo uses a GRADIENT from\n   #00e487 (green, offset .5) → #1ecbd0 (teal, offset 1.0). The\n   PRIMARY brand color is the green — it dominates the visible logo\n   area. The teal at the right edge is a SECONDARY accent.\n\n   First-pass mistake (2026-05-20): I took #1ecbd0 from the report's\n   teal-tinted CSS variables and called it \"the Signify brand\", but\n   that was only the gradient end-stop. Fixed by switching primary\n   to #00e487 and keeping teal as a secondary token.\n\n   Source of truth for fonts (still): the lightmap-report SPA at\n   https://fanta-freak.github.io/lightmap-report/#/report/284\n     → \"Noto Sans\" / \"Barlow Condensed\" / \"JetBrains Mono\".\n\n   Legacy variable names (--signify-green*) are KEPT as aliases for\n   backward compatibility with inline styles in component files; they\n   now resolve to --brand-primary*, which actually IS green.\n\n   ────────────────────────────────────────────────────────────────────── */\n\n:root {\n  /* ── Brand colors ─────────────────────────────────────────────────\n     Pulled DIRECTLY from the official Signify logo SVG (gradient stops):\n        primary green: #00e487 (offset .5, dominates visible logo area)\n        secondary teal: #1ecbd0 (offset 1.0, only the right edge of \"y\")\n     Heading ink + status colors match the lightmap-report exactly:\n        ink:    #1a1a2e\n        pass:   #16a34a   fail: #dc2626   warn: #fbbf24\n        muted:  #6b7280\n  */\n  --brand-primary:       #00e487;   /* primary accent — buttons, bars, badges */\n  --brand-primary-deep:  #00b56b;   /* hover/active for primary buttons */\n  --brand-primary-soft:  #ccfae9;   /* tints for hover rows, badge bg */\n  --brand-primary-faint: #ecfdf6;   /* very soft selection tint */\n  --brand-teal:          #1ecbd0;   /* SECONDARY accent (gradient end-stop) */\n  --brand-teal-deep:     #15a8ad;\n  --brand-ink:           #1a1a2e;   /* heading text */\n  --brand-cobalt:        #0096ff;   /* chart series accent, link blue */\n\n  /* ── Semantic status colors (match the report exactly) ──────────── */\n  --status-pass:       #16a34a;\n  --status-pass-bg:    #dcfce7;\n  --status-fail:       #dc2626;\n  --status-fail-bg:    #fee2e2;\n  --status-warn:       #fbbf24;\n  --status-warn-bg:    #fef3c7;\n  --status-warn-ink:   #92400e;\n  --status-info:       #0096ff;\n  --status-info-bg:    #e0f2fe;\n\n  /* ── Text scale (light theme — dark mode out of scope) ─────────── */\n  --text-strong:       #1a1a2e;   /* h1-h4 */\n  --text-body:         #1f2937;   /* paragraph body */\n  --text-muted:        #6b7280;   /* secondary, helper, table headers */\n  --text-disabled:     #9ca3af;\n  --text-on-brand:     #0a2326;   /* dark text on teal buttons (8.6:1 contrast) */\n  --text-on-dark:      #f3f4f6;\n\n  /* ── Surfaces ──────────────────────────────────────────────────\n     2026-05-21 round 3: deeper page bg (#dde4ee) so white cards REALLY\n     pop. Round 1 used #f4f6fa which Philip called \"viel zu weiß\". This\n     darkens by ~5 luminance steps — still cool blue-tinted, but cards\n     now read as floating panels not flat blocks. Card border + shadow\n     also bumped to reinforce the elevation. */\n  --bg-page:           #dde4ee;   /* tinted canvas under cards */\n  --bg-soft:           #eef1f7;   /* table thead, card-header tint */\n  --bg-canvas:         #d4dde9;   /* deeper soft for chrome zones */\n  --surface-card:      #fff;\n  --surface-hover:     #f4f6fa;\n  --surface-selected:  var(--brand-primary-faint);\n\n  /* ── Lines ────────────────────────────────────────────────────── */\n  --border-default:    #e5e7eb;\n  --border-strong:     #d1d5db;\n  --border-faint:      #f3f4f6;\n\n  /* ── Shadows (calm, low-elevation; bumped 2026-05-21 round 3) ─── */\n  --shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.06);\n  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.06), 0 6px 16px rgba(15, 23, 42, 0.08);\n  --shadow-md: 0 4px 12px rgba(15, 23, 42, 0.12);\n  --shadow-lg: 0 12px 40px rgba(15, 23, 42, 0.20);\n  --shadow-focus: 0 0 0 3px rgba(0, 228, 135, 0.28);  /* brand green */\n\n  /* ── Radii (match report) ─────────────────────────────────────── */\n  --radius-sm: 4px;\n  --radius-md: 6px;\n  --radius-lg: 8px;\n  --radius-xl: 12px;\n  --radius-2xl: 16px;\n  --radius-pill: 999px;\n\n  /* ── Spacing rhythm (4-pt base, TIGHTENED 2026-05-21) ────────────\n     ui-ux-pro-max skill classified this product as \"Data-Dense\n     Dashboard\" which calls for \"minimal padding, space-efficient,\n     maximum data visibility\". The old scale (8/16/24/32/40) was\n     marketing-page generous. Every step shrunk one notch so the\n     existing var(--space-N) callsites stay valid but breathe less. */\n  --space-1:  4px;\n  --space-2:  6px;\n  --space-3:  10px;\n  --space-4:  12px;\n  --space-5:  16px;\n  --space-6:  20px;\n  --space-8:  24px;\n  --space-10: 32px;\n\n  /* ── Typography ──────────────────────────────────────────────────\n     The report uses:\n       sans  : \"Noto Sans\"            body, UI, labels\n       display: \"Barlow Condensed\"    h1/h2 hero, KPI numbers\n       mono  : \"JetBrains Mono\"       tabular figures (Em, U, RG, W)\n     Fonts are loaded from Google Fonts in public/index.html.\n  */\n  --font-sans:    \"Noto Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  --font-display: \"Barlow Condensed\", \"Barlow\", \"Noto Sans\", system-ui, sans-serif;\n  --font-mono:    \"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo, Monaco, monospace;\n\n  /* Type ladder (Tailwind defaults — same ladder the report uses) */\n  --type-xs:   12px;\n  --type-sm:   14px;\n  --type-base: 16px;\n  --type-lg:   18px;\n  --type-xl:   20px;\n  --type-2xl:  24px;\n  --type-3xl:  30px;\n  --type-4xl:  36px;\n\n  --lh-tight:   1.25;\n  --lh-snug:    1.375;\n  --lh-normal:  1.5;\n  --lh-relaxed: 1.625;\n\n  --tracking-tight:   -0.01em;\n  --tracking-normal:  0;\n  --tracking-wide:    0.025em;\n  --tracking-wider:   0.05em;     /* table headers, eyebrow labels */\n  --tracking-widest:  0.1em;\n\n  /* ── Motion (kept short per UI-Pro-Max guidance: 150-300ms) ─── */\n  --motion-fast:   120ms;\n  --motion-base:   180ms;\n  --motion-slow:   240ms;\n  --ease-out:      cubic-bezier(0.16, 1, 0.3, 1);\n  --ease-in-out:   cubic-bezier(0.4, 0, 0.2, 1);\n\n  /* ── Legacy aliases (kept so existing inline styles keep working) */\n  --signify-green:       var(--brand-primary);\n  --signify-green-deep:  var(--brand-primary-deep);\n  --signify-green-soft:  var(--brand-primary-soft);\n  --signify-ink:         var(--brand-ink);\n  --signify-text:        var(--text-body);\n  --signify-muted:       var(--text-muted);\n  --signify-border:      var(--border-default);\n  --signify-bg-soft:     var(--bg-soft);\n  --signify-card:        var(--surface-card);\n  --signify-shadow:      var(--shadow-sm);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Base reset + body font\n   ────────────────────────────────────────────────────────────────────── */\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\nhtml, body, #root { height: 100%; }\n\nbody {\n  font-family: var(--font-sans);\n  font-size: var(--type-base);\n  line-height: var(--lh-normal);\n  color: var(--text-body);\n  background: var(--bg-page);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Improves readability of body text and tabular numerals */\n  font-feature-settings: \"kern\", \"liga\", \"calt\";\n  font-variant-numeric: lining-nums proportional-nums;\n}\n\n/* Headings inherit Noto Sans by default; pages can opt in to the\n   Barlow Condensed display face by adding class .display. */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-sans);\n  color: var(--text-strong);\n  line-height: var(--lh-tight);\n  letter-spacing: var(--tracking-tight);\n  font-weight: 700;\n}\n.display, .display h1, .display h2 {\n  font-family: var(--font-display);\n  font-weight: 600;\n  letter-spacing: var(--tracking-normal);\n  text-transform: none;\n}\n\n/* Use mono for any number that would jitter when values change\n   (Fitness, Em, U, RG, Wattage columns). Apply via class .num. */\n.num, .tabular {\n  font-family: var(--font-mono);\n  font-variant-numeric: tabular-nums lining-nums;\n  font-feature-settings: \"tnum\";\n}\n\n/* Focus ring matches the report's teal accent. Applied to all\n   interactive elements via :focus-visible so mouse users still\n   get a clean look. */\n:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n  border-radius: var(--radius-sm);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   App layout (legacy class names kept — used by Sidebar / MapView)\n   ────────────────────────────────────────────────────────────────────── */\n\n.app {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--bg-page);\n}\n\n.top-bar {\n  height: 60px;\n  background-color: var(--surface-card);\n  display: flex;\n  align-items: center;\n  padding: 0 var(--space-4);\n  gap: var(--space-4);\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border-default);\n}\n\n.main-content {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n\n.sidebar {\n  width: 320px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: var(--surface-card);\n  border-right: 1px solid var(--border-default);\n}\n\n.sidebar-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  margin: 0;\n  background-color: inherit;\n}\n\n.map-wrapper {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n}\n\n.map {\n  width: 100%;\n  flex: 1;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Section heading with green-bar (kept from 2026-05-20 brand pass)\n   Used by ProjectsListPage / CreateProjectPage / ProjectDetailPage.\n   ────────────────────────────────────────────────────────────────────── */\n\n.section-title {\n  position: relative;\n  padding-left: 12px;             /* tightened */\n  margin-bottom: 14px;            /* tightened */\n}\n.section-title::before {\n  content: \"\";\n  position: absolute;\n  left: 0; top: 4px; bottom: 4px;\n  width: 3px;                     /* thinner accent bar */\n  border-radius: 2px;\n  background: var(--brand-primary);\n}\n.section-title h2 {\n  font-size: var(--type-xl);      /* 20px — was 24px, less hero-y */\n  font-weight: 700;\n  color: var(--text-strong);\n  margin: 0;\n  letter-spacing: var(--tracking-tight);\n  line-height: 1.2;\n}\n.section-title .subtitle {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Report-style card (kept) + new variations\n   ────────────────────────────────────────────────────────────────────── */\n\n.report-card {\n  background: var(--surface-card);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);     /* was xl (12px); 8px feels less marketing */\n  box-shadow: var(--shadow-sm);\n  /* No `overflow: hidden` here — that would clip the horizontal\n     scrollbar that .report-card-body.flush creates when the table\n     overflows. Border-radius still clips visual corners visually. */\n  margin-bottom: 12px;                 /* was --space-5 (16) */\n}\n.report-card-header {\n  padding: 10px 14px;                  /* tightened */\n  background: var(--bg-soft);\n  border-bottom: 1px solid var(--border-default);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  /* Clip the header's own bg to the card's rounded top corners. */\n  border-top-left-radius: var(--radius-lg);\n  border-top-right-radius: var(--radius-lg);\n}\n.report-card-header h3 {\n  font-size: 14px;                     /* was --type-lg (18) — more \"tab header\" */\n  font-weight: 700;\n  color: var(--text-strong);\n  margin: 0;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wider);\n}\n.report-card-header .subtitle {\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n.report-card-body {\n  padding: 12px 14px;                  /* was --space-4 (16) --space-5 (20) */\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Buttons — primary / secondary / ghost / icon\n   Sizes: md (default), sm, lg\n   ────────────────────────────────────────────────────────────────────── */\n\n.btn {\n  /* Reset */\n  appearance: none;\n  -webkit-appearance: none;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  letter-spacing: 0;\n  cursor: pointer;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);   /* 6px — tighter, less \"marketing pill\" */\n  padding: 7px 14px;                 /* was 10/16 */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  text-decoration: none;\n  transition:\n    background-color var(--motion-base) var(--ease-out),\n    border-color     var(--motion-base) var(--ease-out),\n    color            var(--motion-base) var(--ease-out),\n    box-shadow       var(--motion-base) var(--ease-out),\n    transform        var(--motion-fast) var(--ease-out);\n  user-select: none;\n  white-space: nowrap;\n}\n.btn:active:not(:disabled) {\n  transform: translateY(1px);\n}\n.btn:disabled,\n.btn[aria-disabled=\"true\"] {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Primary — teal fill, dark ink text (8.6:1 contrast = AAA) */\n.btn-primary {\n  background: var(--brand-primary);\n  color: var(--text-on-brand);\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-xs);\n}\n.btn-primary:hover:not(:disabled) {\n  background: var(--brand-primary-deep);\n  border-color: var(--brand-primary-deep);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Secondary — white surface, teal border + ink text */\n.btn-secondary {\n  background: var(--surface-card);\n  color: var(--text-strong);\n  border-color: var(--border-strong);\n}\n.btn-secondary:hover:not(:disabled) {\n  background: var(--bg-soft);\n  border-color: var(--brand-primary);\n  color: var(--brand-primary-deep);\n}\n\n/* Ghost — text-only, hover reveals soft surface */\n.btn-ghost {\n  background: transparent;\n  color: var(--text-muted);\n  border-color: transparent;\n}\n.btn-ghost:hover:not(:disabled) {\n  background: var(--bg-soft);\n  color: var(--text-strong);\n}\n\n/* Danger — used for destructive actions in the LDT modal */\n.btn-danger {\n  background: var(--surface-card);\n  color: var(--status-fail);\n  border-color: var(--status-fail);\n}\n.btn-danger:hover:not(:disabled) {\n  background: var(--status-fail-bg);\n}\n\n/* Sizes — tightened 2026-05-21 */\n.btn-sm { padding: 4px 10px; font-size: 12px; border-radius: var(--radius-sm); }\n.btn-lg { padding: 9px 18px; font-size: var(--type-sm); }\n\n/* Icon-only button (✎ ✕ archive). Square hit area 30px — still meets\n   the 24px minimum touch target for desktop tools; 44px is mobile-only\n   guidance and would dwarf the row. */\n.btn-icon {\n  padding: 0;\n  width: 30px; height: 30px;\n  border-radius: var(--radius-sm);\n  background: var(--surface-card);\n  color: var(--text-muted);\n  border-color: var(--border-default);\n  font-size: 13px;\n}\n.btn-icon:hover:not(:disabled) {\n  background: var(--bg-soft);\n  color: var(--text-strong);\n  border-color: var(--border-strong);\n}\n\n/* Backward-compat: legacy .app-button used by the wizard top bar */\n.app-button {\n  padding: 8px 14px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-strong);\n  background-color: var(--bg-soft);\n  color: var(--text-strong);\n  text-align: left;\n  font-size: var(--type-sm);\n  font-weight: 500;\n  font-family: inherit;\n  transition: all var(--motion-base) var(--ease-out);\n  margin-right: var(--space-2);\n  cursor: pointer;\n}\n.app-button:hover:not(:disabled) {\n  background-color: #fff;\n  border-color: var(--brand-primary);\n  color: var(--brand-primary-deep);\n}\n.app-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.app-dropdown {\n  height: 36px;\n  padding: 0 12px;\n  font-size: var(--type-sm);\n  font-family: inherit;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-strong);\n  background-color: var(--surface-card);\n  color: var(--text-strong);\n  cursor: pointer;\n  max-width: 280px;\n  text-overflow: ellipsis;\n}\n.app-dropdown:focus {\n  outline: none;\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-focus);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Form fields — label, input, select, textarea\n   ────────────────────────────────────────────────────────────────────── */\n\n.field {\n  display: block;\n  margin-top: 10px;          /* tightened from --space-4 */\n}\n.field-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-strong);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wider);\n  margin-bottom: 4px;\n}\n.field-input,\n.field-select,\n.field-textarea {\n  width: 100%;\n  padding: 7px 10px;         /* tightened from 10/12 */\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  background: var(--surface-card);\n  color: var(--text-strong);\n  font-size: var(--type-sm);\n  font-family: inherit;\n  line-height: 1.4;\n  box-sizing: border-box;\n  transition: border-color var(--motion-base) var(--ease-out),\n              box-shadow   var(--motion-base) var(--ease-out);\n}\n.field-input::placeholder,\n.field-textarea::placeholder { color: var(--text-disabled); }\n\n.field-input:focus,\n.field-select:focus,\n.field-textarea:focus {\n  outline: none;\n  border-color: var(--brand-primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.field-input[readonly] {\n  background: var(--bg-soft);\n  color: var(--text-muted);\n}\n\n.field-help {\n  font-size: var(--type-xs);\n  color: var(--text-muted);\n  margin-top: 6px;\n}\n\n.field-error {\n  font-size: var(--type-xs);\n  color: var(--status-fail);\n  margin-top: 6px;\n  font-weight: 500;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Data table — used by ProjectsListPage, ProjectDetailPage, LDT modal\n   Goal: dense, scannable, with a soft hover lane and a clear-but-quiet\n   header row matching the report's table styling.\n   ────────────────────────────────────────────────────────────────────── */\n\n.data-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13px;          /* one notch under sm — engineering-table density */\n  color: var(--text-body);\n  /* 2026-05-21 round 4: explicit fixed layout. Combined with\n     <colgroup>-defined percentage widths (set per-table by the\n     consuming component), this GUARANTEES all columns fit in the\n     viewport — auto-layout was overflowing because content varied\n     too much. \"Fixed\" here means \"browser respects the col widths\",\n     NOT \"pixel-hardcoded\". Long cell content is clipped with\n     text-overflow on data cells. */\n  table-layout: fixed;\n}\n.data-table td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.data-table thead th {\n  text-align: left;\n  padding: 7px 10px;        /* tightened more 2026-05-21 round 2 */\n  background: var(--bg-soft);\n  border-bottom: 1px solid var(--border-default);\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wider);\n  /* Headers can wrap onto a second line — without this, long German\n     labels (\"LETZTE BERECHNUNG\") force the whole column wider than\n     the viewport. Wrapping costs vertical space (one extra row), saves\n     horizontal space (column fits in the viewport without scroll). */\n  white-space: normal;\n  line-height: 1.2;\n}\n.data-table thead th.sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: color var(--motion-base) var(--ease-out);\n}\n.data-table thead th.sortable:hover {\n  color: var(--brand-primary-deep);\n}\n.data-table tbody td {\n  padding: 8px 12px;        /* tightened 2026-05-21: was 14/16 */\n  border-bottom: 1px solid var(--border-faint);\n  font-size: 13px;\n  vertical-align: middle;\n}\n.data-table tbody tr {\n  transition: background-color var(--motion-fast) var(--ease-out);\n}\n.data-table tbody tr:hover {\n  background: var(--bg-soft);\n}\n.data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n/* Numeric / monospaced data cells (Fitness, Em, U, RG, W) */\n.data-table td.num,\n.data-table th.num {\n  font-family: var(--font-mono);\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n}\n/* Right-aligned action cells */\n.data-table .actions {\n  text-align: right;\n  white-space: nowrap;\n}\n.data-table .actions .btn {\n  margin-left: 4px;\n}\n/* \"Highlighted\" row variant — used for the recommended Calculation */\n.data-table tr.is-recommended {\n  background: var(--brand-primary-faint);\n}\n.data-table tr.is-recommended:hover {\n  background: var(--brand-primary-soft);\n}\n.data-table tr.is-recommended td:first-child {\n  /* Inner left-accent stripe to make the row pop without changing layout */\n  box-shadow: inset 3px 0 0 var(--brand-primary);\n}\n\n/* When a table lives inside a .report-card-body the body shouldn't pad\n   it — apply via .report-card-body.flush. Also allow horizontal scroll\n   inside the card so a wide table doesn't clip at narrow viewports\n   (the page chrome / KPI strip / header buttons stay put either way). */\n.report-card-body.flush {\n  padding: 0;\n  overflow-x: auto;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Status pills / badges — soft tinted backgrounds, color-coded\n   ────────────────────────────────────────────────────────────────────── */\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: var(--radius-pill);\n  font-size: var(--type-xs);\n  font-weight: 600;\n  letter-spacing: var(--tracking-wide);\n  line-height: 1.4;\n  white-space: nowrap;\n}\n.pill-neutral  { background: var(--bg-soft);            color: var(--text-muted); }\n.pill-brand    { background: var(--brand-primary-soft);    color: var(--brand-primary-deep); }\n.pill-pass     { background: var(--status-pass-bg);     color: var(--status-pass); }\n.pill-fail     { background: var(--status-fail-bg);     color: var(--status-fail); }\n.pill-warn     { background: var(--status-warn-bg);     color: var(--status-warn-ink); }\n.pill-info     { background: var(--status-info-bg);     color: var(--status-info); }\n.pill-archived { background: var(--bg-soft);            color: var(--text-disabled); }\n\n/* Solid recommendation badge (★ Empfehlung) — the \"winner\" marker */\n.badge-recommend {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: var(--radius-pill);\n  background: var(--brand-primary);\n  color: var(--text-on-brand);\n  font-size: var(--type-xs);\n  font-weight: 700;\n  letter-spacing: var(--tracking-wide);\n  white-space: nowrap;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   KPI card — compact card showing a single metric. Used by the\n   ProjectDetailPage \"Karten\" view to render each Calculation variant.\n   ────────────────────────────────────────────────────────────────────── */\n\n.kpi-card {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  padding: var(--space-4);\n  background: var(--surface-card);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xs);\n  transition: box-shadow var(--motion-base) var(--ease-out),\n              border-color var(--motion-base) var(--ease-out),\n              transform var(--motion-fast) var(--ease-out);\n}\n.kpi-card:hover {\n  box-shadow: var(--shadow-sm);\n  border-color: var(--border-strong);\n  transform: translateY(-1px);\n}\n.kpi-card.is-recommended {\n  border-color: var(--brand-primary);\n  background:\n    linear-gradient(180deg, var(--brand-primary-faint) 0%, var(--surface-card) 50%);\n  box-shadow: var(--shadow-sm);\n}\n.kpi-card-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-2);\n}\n.kpi-card-title {\n  font-size: var(--type-sm);\n  font-weight: 700;\n  color: var(--text-strong);\n}\n.kpi-card-meta {\n  font-size: var(--type-xs);\n  color: var(--text-muted);\n}\n.kpi-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: var(--type-sm);\n  color: var(--text-body);\n}\n.kpi-row .label { color: var(--text-muted); }\n.kpi-row .value {\n  font-family: var(--font-mono);\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  color: var(--text-strong);\n}\n.kpi-card-actions {\n  display: flex;\n  gap: var(--space-2);\n  margin-top: var(--space-2);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   KPI strip — horizontal row of compact metric tiles, sits at the top\n   of dashboard-like list views (skill recommendation: data-dense\n   dashboards put key metrics near the top so the user gets the state\n   of the world in one glance before scrolling).\n   ────────────────────────────────────────────────────────────────────── */\n\n.kpi-strip {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 8px;\n  margin-bottom: 16px;\n}\n.kpi-tile {\n  background: var(--surface-card);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  padding: 10px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  position: relative;\n  overflow: hidden;\n}\n.kpi-tile::before {\n  /* Thin accent stripe on the left, matches the section-title bar\n     language without taking space. Per-variant color below. */\n  content: \"\";\n  position: absolute;\n  left: 0; top: 0; bottom: 0;\n  width: 3px;\n  background: var(--brand-primary);\n}\n.kpi-tile.is-pass::before { background: var(--status-pass); }\n.kpi-tile.is-warn::before { background: var(--status-warn); }\n.kpi-tile.is-fail::before { background: var(--status-fail); }\n.kpi-tile.is-mute::before { background: var(--text-disabled); }\n\n.kpi-tile-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: var(--tracking-wider);\n}\n.kpi-tile-value {\n  font-family: var(--font-mono);\n  font-variant-numeric: tabular-nums;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-strong);\n  line-height: 1.1;\n}\n.kpi-tile-sub {\n  font-size: 11px;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Modal — used by LDTManagerModal (backdrop + centered card + sticky head)\n   ────────────────────────────────────────────────────────────────────── */\n\n.modal-backdrop {\n  position: fixed; inset: 0;\n  background-color: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(2px);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 9000;\n  animation: modalFade var(--motion-base) var(--ease-out);\n}\n.modal-card {\n  position: relative;\n  background-color: var(--surface-card);\n  width: 92%;\n  max-width: 1000px;\n  max-height: 88vh;\n  border-radius: var(--radius-2xl);\n  box-shadow: var(--shadow-lg);\n  display: flex; flex-direction: column;\n  overflow: hidden;\n  animation: modalSlide var(--motion-slow) var(--ease-out);\n}\n.modal-header {\n  padding: var(--space-5) var(--space-6);\n  border-bottom: 1px solid var(--border-default);\n  display: flex; align-items: center; justify-content: space-between;\n  flex-shrink: 0;\n}\n.modal-header h2 {\n  font-size: var(--type-xl);\n  font-weight: 700;\n  color: var(--text-strong);\n  margin: 0;\n  letter-spacing: var(--tracking-tight);\n}\n.modal-header .modal-meta {\n  font-size: var(--type-xs);\n  color: var(--text-muted);\n  margin-left: var(--space-3);\n  font-weight: 500;\n}\n.modal-close {\n  border: none;\n  background: transparent;\n  font-size: 22px;\n  line-height: 1;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 6px 10px;\n  border-radius: var(--radius-md);\n  transition: background-color var(--motion-fast) var(--ease-out),\n              color var(--motion-fast) var(--ease-out);\n}\n.modal-close:hover {\n  background: var(--bg-soft);\n  color: var(--text-strong);\n}\n.modal-body {\n  padding: var(--space-5) var(--space-6);\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n@keyframes modalFade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n@keyframes modalSlide {\n  from { opacity: 0; transform: translateY(8px) scale(0.99); }\n  to   { opacity: 1; transform: translateY(0)    scale(1); }\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Inline banner — alerts inside a card or modal\n   ────────────────────────────────────────────────────────────────────── */\n\n.banner {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  padding: var(--space-3) var(--space-4);\n  border-radius: var(--radius-md);\n  font-size: var(--type-sm);\n  border: 1px solid transparent;\n  line-height: var(--lh-snug);\n}\n.banner-warn {\n  background: var(--status-warn-bg);\n  border-color: var(--status-warn);\n  color: var(--status-warn-ink);\n}\n.banner-fail {\n  background: var(--status-fail-bg);\n  border-color: var(--status-fail);\n  color: var(--status-fail);\n}\n.banner-info {\n  background: var(--status-info-bg);\n  border-color: var(--brand-cobalt);\n  color: var(--brand-cobalt);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Toast — bottom-center floating message\n   ────────────────────────────────────────────────────────────────────── */\n\n.toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--text-strong);\n  color: #fff;\n  padding: 12px 20px;\n  border-radius: var(--radius-lg);\n  font-size: var(--type-sm);\n  font-weight: 500;\n  box-shadow: var(--shadow-lg);\n  z-index: 9999;\n  pointer-events: none;\n  animation: toastIn var(--motion-base) var(--ease-out);\n  max-width: 90vw;\n  text-align: center;\n}\n@keyframes toastIn {\n  from { opacity: 0; transform: translate(-50%, 8px); }\n  to   { opacity: 1; transform: translate(-50%, 0); }\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   AppHeader chrome (used by the new restructure's top nav)\n   ────────────────────────────────────────────────────────────────────── */\n\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 20px;             /* was 12/32 — leaner top bar */\n  background: var(--surface-card);\n  border-bottom: 1px solid var(--border-default);\n  flex-shrink: 0;\n  gap: var(--space-6);\n}\n.app-header-left {\n  display: flex; align-items: center; gap: var(--space-6);\n}\n.app-header-brand {\n  display: flex; align-items: center; gap: var(--space-3);\n  text-decoration: none;\n}\n.app-header-brand img {\n  height: 26px;                  /* tightened with the header */\n  width: auto;\n  display: block;\n}\n.app-header-divider {\n  width: 1px;\n  height: 22px;\n  background: var(--border-default);\n}\n.app-header-subtitle {\n  font-size: var(--type-xs);\n  font-weight: 600;\n  color: var(--text-strong);\n  letter-spacing: var(--tracking-wider);\n  text-transform: uppercase;\n}\n.app-header-nav {\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n.app-header-nav-link,\n.app-header-nav-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 14px;\n  font-family: inherit;\n  font-size: var(--type-sm);\n  font-weight: 500;\n  color: var(--text-body);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  text-decoration: none;\n  cursor: pointer;\n  transition:\n    color var(--motion-base) var(--ease-out),\n    border-color var(--motion-base) var(--ease-out);\n}\n.app-header-nav-link:hover,\n.app-header-nav-btn:hover {\n  color: var(--brand-primary-deep);\n}\n.app-header-nav-link.is-active {\n  color: var(--text-strong);\n  font-weight: 700;\n  border-bottom-color: var(--brand-primary);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Misc — view-toggle pills, empty state, address suggestion dropdown\n   ────────────────────────────────────────────────────────────────────── */\n\n.view-toggle {\n  display: inline-flex;\n  padding: 4px;\n  background: var(--bg-soft);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  gap: 2px;\n}\n.view-toggle button {\n  appearance: none;\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: var(--type-xs);\n  font-weight: 600;\n  color: var(--text-muted);\n  padding: 6px 14px;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: background-color var(--motion-fast) var(--ease-out),\n              color var(--motion-fast) var(--ease-out);\n}\n.view-toggle button:hover {\n  color: var(--text-strong);\n}\n.view-toggle button.is-active {\n  background: var(--surface-card);\n  color: var(--brand-primary-deep);\n  box-shadow: var(--shadow-xs);\n}\n\n.empty-state {\n  padding: var(--space-8) var(--space-6);\n  text-align: center;\n  color: var(--text-muted);\n  font-size: var(--type-sm);\n  background: var(--bg-soft);\n  border: 1px dashed var(--border-default);\n  border-radius: var(--radius-xl);\n}\n\n/* Nominatim suggestion dropdown */\n.suggest-menu {\n  position: absolute;\n  top: 100%; left: 0; right: 0;\n  z-index: 50;\n  background: var(--surface-card);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  max-height: 240px;\n  overflow-y: auto;\n  margin-top: 4px;\n  padding: 4px;\n}\n.suggest-item {\n  padding: 8px 12px;\n  font-size: var(--type-sm);\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  color: var(--text-body);\n  transition: background-color var(--motion-fast) var(--ease-out);\n}\n.suggest-item:hover {\n  background: var(--brand-primary-faint);\n  color: var(--brand-primary-deep);\n}\n\n/* ──────────────────────────────────────────────────────────────────────\n   Tape measure popup (kept from the wizard map)\n   ────────────────────────────────────────────────────────────────────── */\n.tape-measure-popup .maplibregl-popup-content {\n  background: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  border: none !important;\n}\n.tape-measure-popup .maplibregl-popup-tip { display: none !important; }\n\n/* ──────────────────────────────────────────────────────────────────────\n   Accessibility helpers (per UI-Pro-Max §1)\n   ────────────────────────────────────────────────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  *, *::before, *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
